var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2384_8285)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11601 1.43754C4.35043 1.20312 4.66837 1.07143 4.9999 1.07143C5.33142 1.07143 5.64936 1.20312 5.88378 1.43754C6.0319 1.58566 6.139 1.76712 6.19779 1.96429H3.802C3.86079 1.76712 3.9679 1.58566 4.11601 1.43754ZM2.7061 1.96429C2.78136 1.48086 3.00813 1.03019 3.3584 0.679931C3.79375 0.244579 4.38422 0 4.9999 0C5.61557 0 6.20604 0.244579 6.6414 0.679931C6.99166 1.03019 7.21847 1.48086 7.29368 1.96429H9.28561C9.58147 1.96429 9.82132 2.20414 9.82132 2.5C9.82132 2.79587 9.58147 3.03571 9.28561 3.03571H8.57132V8.92857C8.57132 9.21271 8.45847 9.48529 8.25754 9.68621C8.05661 9.88714 7.78404 10 7.4999 10H2.4999C2.21573 10 1.94321 9.88714 1.74228 9.68621C1.54135 9.48529 1.42847 9.21271 1.42847 8.92857V3.03571H0.714181C0.418314 3.03571 0.178467 2.79587 0.178467 2.5C0.178467 2.20414 0.418314 1.96429 0.714181 1.96429H2.7061ZM3.57132 4.19747C3.81788 4.19747 4.01775 4.39735 4.01775 4.6439V7.50214C4.01775 7.74864 3.81788 7.94857 3.57132 7.94857C3.32477 7.94857 3.1249 7.74864 3.1249 7.50214V4.6439C3.1249 4.39735 3.32477 4.19747 3.57132 4.19747ZM6.8749 4.6439C6.8749 4.39735 6.67502 4.19747 6.42847 4.19747C6.18191 4.19747 5.98204 4.39735 5.98204 4.6439V7.50214C5.98204 7.74864 6.18191 7.94857 6.42847 7.94857C6.67502 7.94857 6.8749 7.74864 6.8749 7.50214V4.6439Z",
    fill: "#BC1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2384_8285"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg13);
export default __webpack_public_path__ + "static/media/svg13.cd33d55e23011e9c6167023c9c9336af.svg";
export { ForwardRef as ReactComponent };